/*
 * @Author: 小周
 * @Date: 2024-07-02 09:17:09
 * @LastEditTime: 2024-07-29 16:52:07
 * @LastEditors: MrZHLF
 * @Description: 更多二级评论
 */

import { useSearchParams } from 'react-router-dom'
import { useEffect, useState, useCallback } from 'react'
import { NavBar } from 'react-vant'
import { getTimer } from '@/utils/timer'

import { getCommentMore } from '@/api/comment'
import BaseUser from '@/components/baseUser'
import CommentPopup from '@/components/commentPopup'
import useCommentFabulousType from '../../hooks/useCommentFabulousType'

import styles from './index.module.scss'

const MoreComponents = () => {
  const [visible, setVisible] = useState(false)
  const [commentObj, setCommentObj] = useState({})
  const [params] = useSearchParams()
  const [item, setItem] = useState({})
  const [commentArray, setCommentArray] = useState([])
  useEffect(() => {
    let obj = JSON.parse(params.getAll('item')[0])
    setItem(obj)
  }, [params])
  const getList = useCallback(async () => {
    let res = await getCommentMore({
      commentId: item.commentId,
    })
    if (res.code == 0 && res.result) {
      setCommentArray(res.result.items)
    }
  }, [item.commentId])

  useEffect(() => {
    if (item.commentId) {
      getList()
    }
  }, [getList, item.commentId])

  const replyComment = (parent, item) => {
    setCommentObj({
      ...parent,
      parentCommentId:
        item && item.commentId ? item.commentId : parent.commentId,
      content: item && item.content ? item.content : parent.content,
      commentUserNickname:
        item && item.commentUserNickname
          ? item.commentUserNickname
          : parent.commentUserNickname,
      commentUserIcon:
        item && item.commentUserIcon
          ? item.commentUserIcon
          : parent.commentUserIcon,
    })
    setVisible(true)
  }

  const handleChildClose = () => {
    setCommentObj({})
    setVisible(false)
  }

  const CommentFooterParent = ({ item }) => {
    const { handleCommentLike, likesFlag } = useCommentFabulousType(item)

    return (
      <div className={styles.right} onClick={() => handleCommentLike(item)}>
        {likesFlag ? (
          <img
            className={styles.icon}
            src={require('./../../assets/images/fabulous_active.png')}
            alt=""
          />
        ) : (
          <img
            className={styles.icon}
            src={require('./../../assets/images/fabulous.png')}
            alt=""
          />
        )}
      </div>
    )
  }

  const CommentFooter = ({ item }) => {
    const { handleCommentLike, likesFlag, likesNum } =
      useCommentFabulousType(item)
    return (
      <div className={styles.item} onClick={() => handleCommentLike(item)}>
        {likesFlag ? (
          <img
            className={styles.icon}
            src={require('./../../assets/images/fabulous_active.png')}
            alt=""
          />
        ) : (
          <img
            className={styles.icon}
            src={require('./../../assets/images/fabulous.png')}
            alt=""
          />
        )}
        <span className={styles.num}>{likesNum}</span>
      </div>
    )
  }

  return (
    <>
      <NavBar
        title="更多评论"
        fixed={true}
        placeholder={true}
        safeAreaInsetTop={true}
      />
      <div className={styles['more-wrapper']}>
        <div className={styles['comment-wrap_list']}>
          <div className={styles['list-wrap_info']}>
            <div className={styles.avatar}>
              <img className={styles.icon} src={item.commentUserIcon} alt="" />
            </div>
            <span className={styles.info}>{item.commentUserNickname}</span>
            <span className={styles.landlord}>楼主</span>
          </div>
        </div>
        <div className={styles.desc}>{item.content}</div>
        <div className={styles['comment_fot']}>
          <div className={styles.left}>
            <div className={styles.date}>{getTimer(item.createTime)}</div>
            <div className={styles.reply} onClick={() => replyComment(item)}>
              回复
            </div>
          </div>
          <CommentFooterParent item={item} />
        </div>
        <div className={styles.comment_children}>
          {commentArray &&
            commentArray.map((child) => {
              return (
                <div
                  className={styles.comment_children_list}
                  key={child.commentId}
                >
                  <BaseUser user={child} />
                  <div className={styles.center}>
                    回复:{' '}
                    <span className={styles.reply}>
                      {child.replyToUserNickname}
                    </span>
                    {child.content}
                  </div>
                  <div className={styles.footer}>
                    <div className={styles.left_part}>
                      <span>{getTimer(child.createTime)}</span>
                      <span className={styles.icon}>|</span>
                      <span onClick={() => replyComment(item, child)}>
                        回复
                      </span>
                    </div>
                    <div className={styles.right_part}>
                      <CommentFooter item={child} />
                    </div>
                  </div>
                </div>
              )
            })}
        </div>
      </div>
      <CommentPopup
        visible={visible}
        onClose={handleChildClose}
        article={item}
        updateList={getList}
        commentObj={commentObj}
      />
    </>
  )
}

export default MoreComponents
